<template>
    <div class="fluid">
        <h1 class="app-title">Pesquisa</h1>
        <b-card>
            <b-row no-gutters>
                <b-col md="12" no-gutters>
                    <form-wizard
                            ref="wizard"
                            nextButtonText="Próximo"
                            backButtonText="Anterior"
                            finishButtonText="Concluir"
                            title
                            subtitle
                            color="#004262" >
                        <wizard-step
                                slot-scope="props"
                                slot="step"
                                :tab="props.tab"
                                :index="props.index"
                        ></wizard-step>
                        <tab-content
                                icon="fa fa-search"
                                class="mx-auto"
                                title="Escolha um dos quatro modos de pesquisa e informe os parâmetros da pesquisa">
                            <ParametrosPesquisa
                                    ref="parametrosPesquisa"
                                    :filtros="filtros"
                                    @consultar="consultar"/>
                        </tab-content>
                        <tab-content
                                icon="fa fa-file-text-o"
                                class="mx-auto"
                                title="Resultado da Pesquisa" >
                            <TabelaPesquisas
                                    ref="tabelaPesquisas"
                                    :resultado="resultado"
                                    :configTable="configTable"
                                    :filtros="filtros"
                                    :selecteds="selecteds"
                                    :loadPDF="loadPDF"
                                    :loadCSV="loadCSV"
                                    :loadEF="loadEF"
                                    @openFilterPopup="openFilterPopup"
                                    @consultar="consultar"
                                    @limparFiltros="limparFiltros"
                                    @hideModalCdaErro="hideModalCdaErro"
                                    @resetIgnorarFechar="resetIgnorarFechar"
                                    @exportPDF="exportPDF"
                                    @exportCSV="exportCSV"
                                    @showModalRelatorioEf="showModalRelatorioEf"
                                    @exibir="exibir"
                                    @atualizarValor="atualizarValor"
                                    @voltar="voltar"
                                    />
                        </tab-content>

                        <template slot="footer" slot-scope="props" class="pb-0">
                            <hr class="mt-0 mb-2"/>
                            <div class="row justify-content-center">
                                <div class="d-flex justify-content-between mb-3">
                                    <div v-if="props.activeTabIndex == 0">
                                        <b-button
                                                id="btnProxima"
                                                @click="pesquisar"
                                                variant="primary">
                                            Pesquisar
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </form-wizard>
                </b-col>
            </b-row>
        </b-card>
        
        <b-modal ref="modalRelatorioEf" size="lg" title="Relatório para EF" cancel-title="Fechar">
            <b-alert
                    variant="danger"
                    :show="msgErroFormulario">{{ msgErroFormulario }}</b-alert>
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p>Deseja acrescentar honorários no Relatorio?</p>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <div style="margin-left: 15px; margin-bottom: 15px;">
                    <b-form-radio-group id="radio-tipo-relatorio" v-model="tipoRelatorio" name="radio-tipo-relatorio">
                        <b-form-radio value="0">Acrescentar o percentual de</b-form-radio>
                    </b-form-radio-group>
                </div>
                <div>
                    <b-form-input :disabled="tipoRelatorio != 0"
                                  name="percentualRelatorio"
                                  v-model="percentualRelatorio"
                                  type="text"
                                  maxlength="3"
                                  size="10"
                                  v-mask="['###']" />
                </div>
                <div style="margin: auto; margin-left: 4px;">%</div>
                <b-col xs="12" md="12" class="mx-auto"></b-col>
                <div style="margin-left: 15px;">
                    <b-form-radio-group id="radio-tipo-relatorio" v-model="tipoRelatorio" name="radio-tipo-relatorio">
                        <b-form-radio value="1">Acrescentar o valor fixo de R$</b-form-radio>
                    </b-form-radio-group>
                </div>
                <div>
                    <money :disabled="tipoRelatorio != 1"
                           class="form-control"
                           v-model="valorRelatorio"
                           v-bind="money"
                    ></money>
                </div>
                <b-col xs="12" md="12" class="mx-auto">
                    <b-form-radio-group id="radio-tipo-relatorio" v-model="tipoRelatorio" name="radio-tipo-relatorio">
                        <b-form-radio value="2">Sem honorários e com o texto "Valor sem honorários"</b-form-radio>
                    </b-form-radio-group>
                </b-col>
                <b-col xs="12" md="12" class="mx-auto">
                    <b-form-radio-group id="radio-tipo-relatorio" v-model="tipoRelatorio" name="radio-tipo-relatorio">
                        <b-form-radio value="3">Sem honorários e sem texto</b-form-radio>
                    </b-form-radio-group>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{  }">
                <div class="d-flex justify-content-between">
                    <b-button size="md" variant="success" @click="gerarRelatorioEf(false)" class="float-left" :disabled="loadEF">
                        <b-spinner small v-if="loadEF"></b-spinner>
                        Gerar Relatório
                    </b-button>
                    <b-button variant="secondary" class="fonte-branca ml-1" @click="hideModalRelatorioEf">
                        Voltar
                    </b-button>
                </div>
            </template>
        </b-modal>

        <b-modal ref="modalCdaErro" size="lg" :title="'CDA ' + this.filtros.numeroDivida + ' não ajuizada ou protestada!'" cancel-title="Fechar" @hidden="hideModalCdaErro">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p>Não há registro no PROAJU de ajuizamento ou de protesto para a CDA pesquisada. Deseja abrir a tela de consulta aos dados da CDA?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{  }">
                <div class="d-flex justify-content-between">
                    <b-button variant="secondary" class="fonte-branca mr-1" @click="hideModalCdaErro">
                        Voltar
                    </b-button>
                    <b-button size="md" variant="primary" @click="abrirModalCda();hideModalCdaErro();" class="float-left">
                        Abrir Consulta CDA
                    </b-button>
                </div>
            </template>
        </b-modal>

        <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
    </div>
</template>

<script>
    import {FormWizard, TabContent, WizardStep} from 'vue-form-wizard';

    import axios from 'axios';
    import 'vue-form-wizard/dist/vue-form-wizard.min.css';
    import ParametrosPesquisa from "./components/ParametrosPesquisa";
    import TabelaPesquisas from "./components/TabelaPesquisas";
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";
    import formatarMixins from '../../mixins/formatarMixins';

    export default {
        components: {
            ParametrosPesquisa,
            TabelaPesquisas,
            FormWizard,
            TabContent,
            WizardStep,
            CompFiltroGrid
        },
        mixins: [ formatarMixins ],
        data() {
            return {
                urlApi: null,
                token: null,
                ignorarFechar: false,
                money: {
                    decimal: ',',
                    thousands: '.',
                    precision: 2,
                    masked: false
                },
                configTable: {
                    perPage: 100,
                    sortField: 'cda.numerodivida',
                    sortOrder: 'asc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                    totalGeral: 0,
                    quantidadeGeral: 0,
                    totalProcessos: 0,
                    visible: false
                },
                resultado: [],
                selecteds: [],
                loadCSV: false,
                loadPDF: false,
                loadEF: false,
                tipoRelatorio: 3,
                percentualRelatorio: null,
                valorRelatorio: null,
                showColunms: [],
                msgErroFormulario: null,
                filtro: {
                    tipo: null,
                    campoFiltro: null,
                    filtrarEm: null,
                    campoValor: null,
                    campoMascara: null,
                    listaValores: []
                },
                filtros: {
                    numeroDivida: null,
                    cnj: null,
                    cpfCnpj: null,
                    nomeDevedor: null,
                    dataInicio: null,
                    dataFinal: null,
                    numeroDividaSub: null,
                    filtrarDevedor: null,
                    devedor: null,
                    cpfCnpjSub: null,
                    filtrarOrigem: null,
                    origem: null,
                    filtrarTipoCredito: null,
                    tipoCredito: null,
                    tipoCobranca: null,
                    cnjSub: null,
                    filtrarDataAtualizacao: null,
                    dataAtualizacao: null,
                    filtrarValor: null,
                    valor: null,
                    filtrarStatusFir: null,
                    statusFir: null,
                    statusProtesto: null,
                    filtrarComarca: null,
                    comarca: null,
                    filtrarJuizo: null,
                    juizo: null,
                    filtrarAssunto: null,
                    assunto: null,
                    faseCda: null,
                    ocorrenciaAjuizamento: null,
                    ocorrenciaProtesto: null
                },
                load: false
            }
        },
        methods: {
            async pesquisar() {
                this.filtros = {
                    numeroDivida: this.filtros.numeroDivida,
                    cnj: this.filtros.cnj,
                    cpfCnpj: this.filtros.cpfCnpj,
                    nomeDevedor: this.filtros.nomeDevedor,
                    dataInicio: this.filtros.dataInicio,
                    dataFinal: this.filtros.dataFinal,
                    numeroDividaSub: null,
                    filtrarDevedor: null,
                    devedor: null,
                    cpfCnpjSub: null,
                    filtrarOrigem: null,
                    origem: null,
                    filtrarTipoCredito: null,
                    tipoCredito: null,
                    tipoCobranca: null,
                    cnjSub: null,
                    filtrarDataAtualizacao: null,
                    dataAtualizacao: null,
                    filtrarValor: null,
                    valor: null,
                    filtrarStatusFir: null,
                    statusFir: null,
                    filtrarAssunto: null,
                    assunto: null,
                    statusProtesto: null,
                    filtrarComarca: null,
                    comarca: null,
                    filtrarJuizo: null,
                    juizo: null,
                    faseCda: null,
                    ocorrenciaAjuizamento: null,
                    ocorrenciaProtesto: null
                };

                this.ignorarFechar = false;

                this.$store.commit("setMessages", {});

                if(this.filtros.cnj != null && this.filtros.cnj != "" && (this.filtros.cnj.length < 25 || !this.validaCnj(this.filtros.cnj))) {
                    this.exibirMensagem('CNJ inválido.');
                    return;
                }
                if((this.filtros.dataInicio != null && this.filtros.dataInicio != "") || (this.filtros.dataFinal != null && this.filtros.dataFinal != "")) {
                    let dataInicial = this.filtros.dataInicio != null && this.filtros.dataInicio != "" ?
                        parseInt(this.filtros.dataInicio.split("-")[0] + "" + this.filtros.dataInicio.split("-")[1] + "" + this.filtros.dataInicio.split("-")[2])
                        : null;
                    let dataFinal = this.filtros.dataFinal != null && this.filtros.dataFinal != "" ?
                        parseInt(this.filtros.dataFinal.split("-")[0] + "" + this.filtros.dataFinal.split("-")[1] + "" + this.filtros.dataFinal.split("-")[2])
                        : null;

                    var dataAtual = new Date();
                    let dataAtualTratada = parseInt(dataAtual.getFullYear()
                        + "" + (dataAtual.getMonth() < 9 ? "0" : "") + (dataAtual.getMonth() + 1)
                        + "" + (dataAtual.getDate() < 10 ? "0" : "") + (dataAtual.getDate() + 1));

                    if(dataInicial != null && dataInicial > dataAtualTratada) {
                        this.exibirMensagem("A Data de Início não pode ser maior que a data atual.");
                        return;
                    } else if(dataFinal != null && dataFinal > dataAtualTratada) {
                        this.exibirMensagem("A Data Final não pode ser maior que a data atual.");
                        return;
                    } else if(dataInicial != null && dataFinal != null && dataInicial > dataFinal) {
                        this.exibirMensagem("A Data de Início não pode ser maior que a Data Final.");
                        return;
                    }
                }

                this.selecteds = [];

                this.$refs.wizard.nextTab();

                this.configTable.visible = true;
                this.consultar();
            },
            async voltar() {
                this.$refs.wizard.reset();
            },

            async consultar() {
                let perPageStr = `&perPage=${this.configTable.perPage}`;
                if (this.configTable.perPage === 'Todos') {
                    perPageStr = '';
                    this.configTable.currentPage = 1;
                    this.configTable.rows = 0;
                }

                let filtrosPesquisa = {
                    ...this.filtros
                };

                filtrosPesquisa.nomeDevedor = this.filtros.nomeDevedor != null ? this.filtros.nomeDevedor.nome : '';

                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/consultarCdas/consultarTotais`, filtrosPesquisa, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then(response => {
                    this.configTable.quantidadeGeral = response.data.rows;
                    this.configTable.rows = response.data.rows;
                    this.configTable.totalGeral = response.data.valorTotal;
                    this.configTable.totalProcessos = response.data.totalProcessos;
                });
                axios.post(`${this.urlApi}/v1/consultarCdas/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtrosPesquisa, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then(response => {
                    this.resultado = response.data.resultado;

                    if((this.resultado == null || this.resultado.length <= 0) && this.filtros.numeroDivida) {
                        this.showModalCdaErro();
                    } else {
                        this.configTable.checkedAll = true;
                        this.resultado.forEach(result => {
                            result.checked = false;
                            this.selecteds.forEach(selected => {
                                if(result.codCdaSefa == selected.codCdaSefa) {
                                    const index = this.selecteds.indexOf(selected);
                                    this.selecteds.splice(index, 1);

                                    this.selecteds.push(result);
                                    result.checked = true;
                                }
                            });

                            if(!this.selecteds.includes(result)) {
                                this.configTable.checkedAll = false
                            }
                        });
                    }
                }).finally(() => {
                    this.configTable.load = false;
                });
            },

            atualizarValor() {
                let codigos = [];
                this.selecteds.forEach(d => {
                    codigos.push(d.codCdaSefa);
                });
                
                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/consultarCdas/atualizarValor`, codigos, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then((resp) => {
                    if(resp.data) {
                        this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: [`${resp.data.message}`] });
                        window.scrollTo(0,0);
                        return
                    }
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Operação realizada com sucesso!!!'] });
                    this.selecteds = [];
                    this.configTable.checkedAll = false;
                }).finally(() => {
                    this.configTable.currentPage = 1;
                    this.configTable.load = false;
                    this.consultar();
                })
            },
            
            openFilterPopup(campo, tipo, values, mascara, event) {
                if(document.getElementById('popup').style.display == 'block'
                    && this.filtro.campoFiltro == campo) {
                    this.$refs.compFiltro.closeFilterPopup();
                } else {
                    this.filtro.tipo = tipo;
                    this.filtro.campoFiltro = campo;
                    this.filtro.mascara = mascara;

                    if(this.filtro.campoFiltro == 'Número da Dívida') {
                        this.filtro.campoMascara = this.filtros.numeroDividaSub;
                    } else if(this.filtro.campoFiltro == 'Contribuinte') {
                        this.filtro.filtrarEm = this.filtros.filtrarDevedor;
                        this.filtro.campoValor = this.filtros.devedor;
                    } else if(this.filtro.campoFiltro == 'CPF/CNPJ') {
                        this.filtro.campoMascara = this.filtros.cpfCnpjSub;
                    } else if(this.filtro.campoFiltro == 'Tipo de Crédito') {
                        this.filtro.filtrarEm = this.filtros.filtrarTipoCredito;
                        this.filtro.campoValor = this.filtros.tipoCredito;
                    } else if(this.filtro.campoFiltro == 'Origem') {
                        this.filtro.filtrarEm = this.filtros.filtrarOrigem;
                        this.filtro.campoValor = this.filtros.origem;
                    } else if(this.filtro.campoFiltro == 'Tipo de Cobrança') {
                        this.filtro.campoValor = this.filtros.tipoCobranca;
                    } else if(this.filtro.campoFiltro == 'Execução Fiscal') {
                        this.filtro.campoMascara = this.filtros.cnjSub;
                    } else if(this.filtro.campoFiltro == 'Assunto') {
                        this.filtro.filtrarEm = this.filtros.filtrarAssunto;
                        this.filtro.assunto = this.filtros.assunto;
                    } else if(this.filtro.campoFiltro == 'Data Atualização') {
                        this.filtro.filtrarEm = this.filtros.filtrarDataAtualizacao;
                        this.filtro.campoValor = this.filtros.dataAtualizacao;
                    } else if(this.filtro.campoFiltro == 'Valor') {
                        this.filtro.filtrarEm = this.filtros.filtrarValor;
                        this.filtro.campoValor = this.filtros.valor;
                    } else if(this.filtro.campoFiltro == 'Status FIR') {
                        this.filtro.filtrarEm = this.filtros.filtrarStatusFir;
                        this.filtro.campoValor = this.filtros.statusFir;
                    } else if(this.filtro.campoFiltro == 'Status Protesto') {
                        this.filtro.campoValor = this.filtros.statusProtesto;
                    } else if(this.filtro.campoFiltro == 'Fase CDA') {
                        this.filtro.campoValor = this.filtros.faseCda;
                    } else if(this.filtro.campoFiltro == 'Ocorrência Ajuizamento') {
                        this.filtro.campoValor = this.filtros.ocorrenciaAjuizamento;
                    } else if(this.filtro.campoFiltro == 'Ocorrência Protesto') {
                        this.filtro.campoValor = this.filtros.ocorrenciaProtesto;
                    } else if(this.filtro.campoFiltro == 'Comarca') {
                        this.filtro.filtrarEm = this.filtros.filtrarComarca;
                        this.filtro.assunto = this.filtros.comarca;
                    } else if(this.filtro.campoFiltro == 'Juízo') {
                        this.filtro.filtrarEm = this.filtros.filtrarJuizo;
                        this.filtro.campoValor = this.filtros.juizo;
                    }

                    if(this.filtro.tipo == "checkbox" || this.filtro.tipo == "combo") {
                        this.filtro.listaValores = values;
                    } else if(values != null && values != "") {
                        this.filtro.listaValores = values.split(',');
                    }

                    this.$refs.compFiltro.openCloseFilterPopup(event);
                }
            },
            filtrarResultados(limpar) {
                if(limpar) {
                    this.filtro.filtrarEm = null;
                    this.filtro.campoValor = null;
                    this.filtro.campoMascara = null;
                }

                if(this.filtro.campoFiltro == 'Número da Dívida') {
                    this.filtros.numeroDividaSub = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Contribuinte') {
                    this.filtros.filtrarDevedor = this.filtro.filtrarEm;
                    this.filtros.devedor = this.filtro.campoValor;
                } else if(this.filtro.campoFiltro == 'CPF/CNPJ') {
                    this.filtros.cpfCnpjSub = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Tipo de Crédito') {
                    this.filtros.filtrarTipoCredito = this.filtro.filtrarEm;
                    this.filtros.tipoCredito = this.filtro.campoValor;
                } else if(this.filtro.campoFiltro == 'Origem') {
                    this.filtros.filtrarOrigem = this.filtro.filtrarEm;
                    this.filtros.origem = this.filtro.campoValor;
                } else if(this.filtro.campoFiltro == 'Tipo de Cobrança') {
                    this.filtros.tipoCobranca = this.filtro.campoValor;
                } else if(this.filtro.campoFiltro == 'Execução Fiscal') {
                    this.filtros.cnjSub = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Assunto') {
                    this.filtros.filtrarAssunto = this.filtro.filtrarEm;
                    this.filtros.assunto = this.filtro.campoValor;
                } else if(this.filtro.campoFiltro == 'Data Atualização') {
                    this.filtros.filtrarDataAtualizacao = this.filtro.filtrarEm;
                    this.filtros.dataAtualizacao = this.filtro.campoValor;
                } else if(this.filtro.campoFiltro == 'Valor') {
                    this.filtros.filtrarValor = this.filtro.filtrarEm;
                    this.filtros.valor = this.filtro.campoValor;
                } else if(this.filtro.campoFiltro == 'Status FIR') {
                    this.filtros.filtrarStatusFir = this.filtro.filtrarEm;
                    this.filtros.statusFir = this.filtro.campoValor;
                } else if(this.filtro.campoFiltro == 'Status Protesto') {
                    this.filtros.statusProtesto = this.filtro.campoValor;
                } else if(this.filtro.campoFiltro == 'Fase CDA') {
                    this.filtros.faseCda = this.filtro.campoValor;
                } else if(this.filtro.campoFiltro == 'Ocorrência Ajuizamento') {
                    this.filtros.ocorrenciaAjuizamento = this.filtro.campoValor;
                } else if(this.filtro.campoFiltro == 'Ocorrência Protesto') {
                    this.filtros.ocorrenciaProtesto = this.filtro.campoValor;
                } else if(this.filtro.campoFiltro == 'Comarca') {
                    this.filtros.filtrarComarca = this.filtro.filtrarEm;
                    this.filtros.comarca = this.filtro.campoValor;
                } else if(this.filtro.campoFiltro == 'Juízo') {
                    this.filtros.filtrarJuizo = this.filtro.filtrarEm;
                    this.filtros.juizo = this.filtro.campoValor;
                }

                this.configTable.currentPage = 1;

                this.consultar();
            },
            ordenarResultados(order) {
                if(this.filtro.campoFiltro == 'Número da Dívida') {
                    this.configTable.sortField = 'cda.numerodivida';
                } else if(this.filtro.campoFiltro == 'Contribuinte') {
                    this.configTable.sortField = 'devedor.nome';
                } else if(this.filtro.campoFiltro == 'CPF/CNPJ') {
                    this.configTable.sortField = 'devedor.numerocpfcnpj';
                } else if(this.filtro.campoFiltro == 'Tipo de Crédito') {
                    this.configTable.sortField = 'tipoCredito';
                } else if(this.filtro.campoFiltro == 'Origem') {
                    this.configTable.sortField = 'cda.origem';
                } else if(this.filtro.campoFiltro == 'Tipo de Cobrança') {
                    this.configTable.sortField = 'cda.indtipoeventopge';
                } else if(this.filtro.campoFiltro == 'Execução Fiscal') {
                    this.configTable.sortField = 'processo.numerounico';
                } else if(this.filtro.campoFiltro == 'Assunto') {
                    this.configTable.sortField = 'assuntoprocesso';
                } else if(this.filtro.campoFiltro == 'Data Atualização') {
                    this.configTable.sortField = 'cda.datahoraconsultapagamentoparcelamento';
                } else if(this.filtro.campoFiltro == 'Valor') {
                    this.configTable.sortField = 'cda.valortotalatualizado';
                } else if(this.filtro.campoFiltro == 'Status FIR') {
                    this.configTable.sortField = 'cda.statusdae';
                } else if(this.filtro.campoFiltro == 'Status Protesto') {
                    this.configTable.sortField = 'statusProcesso';
                } else if(this.filtro.campoFiltro == 'Fase CDA') {
                    this.configTable.sortField = 'cda.indtipomonitoramento';
                } else if(this.filtro.campoFiltro == 'Ocorrência Ajuizamento') {
                    this.configTable.sortField = 'processo.indstatusprocesso';
                } else if(this.filtro.campoFiltro == 'Ocorrência Protesto') {
                    this.configTable.sortField = 'retornosolucaoprotesto.ind_ocorrencia_t33_a2';
                } else if(this.filtro.campoFiltro == 'Comarca') {
                    this.configTable.sortField = 'comarca.nomesimplificado';
                } else if(this.filtro.campoFiltro == 'Juízo') {
                    this.configTable.sortField = 'juizo.nome';
                }

                this.configTable.sortOrder = order;

                this.consultar();
            },
            limparFiltros() {
                this.filtros = {
                    numeroDivida: this.filtros.numeroDivida,
                    cnj: this.filtros.cnj,
                    cpfCnpj: this.filtros.cpfCnpj,
                    nomeDevedor: this.filtros.nomeDevedor,
                    dataInicio: this.filtros.dataInicio,
                    dataFinal: this.filtros.dataFinal,
                    numeroDividaSub: null,
                    filtrarDevedor: null,
                    devedor: null,
                    cpfCnpjSub: null,
                    filtrarOrigem: null,
                    origem: null,
                    tipoCobranca: null,
                    cnjSub: null,
                    filtrarDataAtualizacao: null,
                    dataAtualizacao: null,
                    filtrarValor: null,
                    valor: null,
                    filtrarStatusFir: null,
                    statusFir: null,
                    statusProtesto: null,
                    filtrarComarca: null,
                    comarca: null,
                    filtrarJuizo: null,
                    juizo: null,
                    filtrarAssunto: null,
                    assunto: null,
                    faseCda: null,
                    ocorrenciaAjuizamento: null,
                    ocorrenciaProtesto: null
                };

                this.consultar();
            },

            showModalRelatorioEf () {
                const filtro = {
                    ...this.filtros,
                    listaSelecionadas: this.selecteds
                };

                if(filtro.nomeDevedor != null) {
                    filtro.nomeDevedor = filtro.nomeDevedor.nome;
                }

                this.tipoRelatorio = 3;
                this.percentualRelatorio = null;
                this.valorRelatorio = null;

                axios.post(`${this.urlApi}/v1/consultarCdas/verificarAtualizacaoCdas`, filtro,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    })
                    .then(response => {
                        if(response.data) {
                            this.$bvModal.msgBoxConfirm('ATENÇÃO! Entre as dívidas selecionadas, consta CDA não atualizada para a data de hoje!', {
                                title: 'Atenção!',
                                okTitle: 'Continuar Mesmo Assim',
                                cancelTitle: 'Voltar',
                                okVariant: 'success',
                                centered: true,
                                hideHeaderClose: false,
                                footerClass: 'p-2'
                            }).then((value) => {
                                if(value) {
                                    this.$refs['modalRelatorioEf'].show();
                                }
                            });
                        } else {
                            this.$refs['modalRelatorioEf'].show();
                        }
                    }).finally(() => {
                    this.loadEF = false
                });
            },

            hideModalRelatorioEf () {
                this.$refs['modalRelatorioEf'].hide();
            },

            exibir() {
                if(this.selecteds[0]) {
                    this.$store.commit('setCDA', this.selecteds[0]);
                    this.$store.commit('setRecoverFilterCDA', false);
                    this.$store.commit('setConfigTableCDA', this.configTable);
                    this.$store.commit('setFiltroCDA', this.filtros);
                    this.$router.push({ path: `/consultar-cdas/exibir/${this.selecteds[0].codCdaSefa}` })
                }
            },

            exportCSV() {
                this.loadCSV = true;

                const filtro = {
                    ...this.filtros,
                    listaSelecionadas: this.selecteds
                };

                if(filtro.nomeDevedor != null) {
                    filtro.nomeDevedor = filtro.nomeDevedor.nome;
                }

                axios.post(`${this.urlApi}/v1/consultarCdas/exportarCsv?sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                })
                .then(response => {
                    this.downloadCSV(response)
                }).finally(() => {
                    this.loadCSV = false
                })
            },

            exportPDF() {
                this.loadPDF = true;

                const filtro = {
                    ...this.filtros,
                    listaSelecionadas: this.selecteds
                };

                if(filtro.nomeDevedor != null) {
                    filtro.nomeDevedor = filtro.nomeDevedor.nome;
                }

                axios.post(`${this.urlApi}/v1/consultarCdas/exportarPDF?sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    },
                    responseType: 'arraybuffer'
                })
                .then(response => {
                    this.downloadPDF(response, 'pdf-carta.pdf')
                }).finally(() => {
                    this.loadPDF = false
                })
            },

            gerarRelatorioEf(ignorarAtualizar) {
                this.msgErroFormulario = null;

                if(this.tipoRelatorio == 0 && this.percentualRelatorio > 100) {
                    this.msgErroFormulario = "Limite de percentual acima do limite de 100%";
                    return;
                }

                this.loadEF = true;

                const filtro = {
                    ...this.filtros,
                    listaSelecionadas: this.selecteds,
                    tipoRelatorio: this.tipoRelatorio,
                    percentualRelatorio: this.percentualRelatorio,
                    valorRelatorio: this.valorRelatorio
                };

                if(filtro.nomeDevedor != null) {
                    filtro.nomeDevedor = filtro.nomeDevedor.nome;
                }

                axios.post(`${this.urlApi}/v1/consultarCdas/exportarPDFEF?sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    },
                    responseType: 'arraybuffer'
                }).then(response => {
                    this.downloadPDF(response, 'relatorio-ef.pdf');
                }).finally(() => {
                    this.loadEF = false
                    this.hideModalRelatorioEf();
                });
            },

            downloadCSV(response) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'cdas.csv');
                document.body.appendChild(link);
                link.click();
            },

            downloadPDF(response, nome) {
                let blob = new Blob([response.data], { type: 'application/pdf' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = nome;
                link.click();
            },

            showModalCdaErro () {
                this.$refs['modalCdaErro'].show();
            },
            hideModalCdaErro () {
                if(!this.ignorarFechar && (this.resultado == null || this.resultado.length <= 0) && this.filtros.numeroDivida) {
                    this.filtros = {
                        numeroDivida: null,
                        cnj: null,
                        cpfCnpj: null,
                        nomeDevedor: null,
                        dataInicio: null,
                        dataFinal: null,
                        numeroDividaSub: null,
                        filtrarDevedor: null,
                        devedor: null,
                        cpfCnpjSub: null,
                        filtrarOrigem: null,
                        origem: null,
                        tipoCobranca: null,
                        cnjSub: null,
                        filtrarDataAtualizacao: null,
                        dataAtualizacao: null,
                        filtrarValor: null,
                        valor: null,
                        filtrarStatusFir: null,
                        statusFir: null,
                        statusProtesto: null,
                        filtrarComarca: null,
                        comarca: null,
                        filtrarJuizo: null,
                        juizo: null,
                        filtrarAssunto: null,
                        assunto: null,
                        faseCda: null,
                        ocorrenciaAjuizamento: null,
                        ocorrenciaProtesto: null
                    };

                    this.$refs.wizard.reset();
                    this.$refs.parametrosPesquisa.focusNumeroDivida();
                }
                this.$refs['modalCdaErro'].hide();
            },
            abrirModalCda () {
                this.ignorarFechar = true;
                this.$refs.tabelaPesquisas.abrirModalExtratoCda(this.filtros.numeroDivida);
            },
            resetIgnorarFechar () {
                this.ignorarFechar = false;
            },
        },

        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).token.access_token;

            const recoverFilter = this.$store.getters.getRecoverFilterCDA;
            if(recoverFilter) {
                const filtro = this.$store.getters.getFiltroCDA;
                const configTable = this.$store.getters.getConfigTableCDA;
                this.filtros = { ...filtro }
                this.configTable = { ...configTable }

                if(configTable.visible) {
                    this.consultar();
                    this.$refs.wizard.nextTab();
                }

                this.$store.commit('setRecoverFilterCDA', false)
            }
        },

    }
</script>
